import { createAction } from 'redux-actions';

import {
  REQUEST_ALL_USERS_SUCCESS,
  REQUEST_ALL_USERS_FAILURE,
  REQUEST_USER_DETAILS_SUCCESS,
  REQUEST_USER_DETAILS_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  USERS_EXPORT_CSV_SUCCESS,
  USERS_EXPORT_CSV_FAILURE,
  GET_OPTED_USER_BRANDS,
  GET_OPTED_USER_BRANDS_FAILURE
} from '../constants/actionTypes';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbar';
import * as UserManager from '../api/userManager';

const requestAllUserSuccess = createAction(REQUEST_ALL_USERS_SUCCESS);
const requestAllUserFailure = createAction(REQUEST_ALL_USERS_FAILURE);

export function getAllUsers() {
  return dispatch => UserManager.getAllUsers()
  .then(({ data }) =>{

   dispatch(requestAllUserSuccess(data))

  })
   .catch((error) => {
    dispatch(requestAllUserFailure(error));
    if(error?.response?.status === 401){
      dispatch(showErrorSnackbar('Session is Expired!!!'));
    }else{
      dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
    }
  });
}

const requestUserDetailsSuccess = createAction(REQUEST_USER_DETAILS_SUCCESS);
const requestUserDetailsFailure = createAction(REQUEST_USER_DETAILS_FAILURE);

export function getUserDetails(params) {
  return dispatch => UserManager.getUserDetails(params).then(({ data }) => dispatch(requestUserDetailsSuccess(data))).catch((error) => {
    dispatch(requestUserDetailsFailure(error));
    if(error?.response?.status === 401){
      dispatch(showErrorSnackbar('Session is Expired!!!'));
    }else{
    dispatch(showErrorSnackbar('Failed to fetch subscriber user detail'));}
  });
}


const createUserFailure = createAction(CREATE_USER_FAILURE);

export function createUser(params) {
  return dispatch => UserManager.createUser(params)
    .then(({ data }) => {
   
      dispatch(getAllUsers());
      dispatch(showSuccessSnackbar('Subscriber user created'));
      return true;
    })
    .catch((error) => {
      dispatch(createUserFailure(error));
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
        dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
      }
      return false;
    });
}


const updateUserFailure = createAction(UPDATE_USER_FAILURE);

export function updateUserDetails(params) {
  return dispatch => UserManager.updateUserDetails(params)
    .then(({ data }) => {
      
      dispatch(getAllUsers());
      dispatch(showSuccessSnackbar('Subscriber user updated'));
      return true;
    })
    .catch((error) => {
      dispatch(updateUserFailure(error));
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(showErrorSnackbar('Failed to update subscriber user'));}
      return false;
    });
}


const deleteUserFailure = createAction(DELETE_USER_FAILURE);


export function deleteUsers(params) {
  return dispatch => UserManager.deleteUser(params)
    .then(({ data }) => {
     
      dispatch(getAllUsers());
      dispatch(showSuccessSnackbar('Successfully deleted subscriber user(s)'));
    })
    .catch((error) => {
      dispatch(deleteUserFailure(error));

      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
        dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
      }
    });
}

const usersExportCsvSuccess = createAction(USERS_EXPORT_CSV_SUCCESS);
const usersExportCsvFailure = createAction(USERS_EXPORT_CSV_FAILURE);

export function exportCSV(params) {
  return dispatch => UserManager.exportCSV(params).then(({ data }) => dispatch(usersExportCsvSuccess(data))).catch((error) => {
    dispatch(usersExportCsvFailure(error));
    if(error?.response?.status === 401){
      dispatch(showErrorSnackbar('Session is Expired!!!'));
    }else{
    dispatch(showErrorSnackbar('Failed to export CSV'));}
  });
}

export function updateUserFromSearch(data) {
  return dispatch =>  {
    dispatch(requestAllUserSuccess({data}))
  };
}

const requestOptedUserBrands = createAction(GET_OPTED_USER_BRANDS);
const requestOptedUserBrandsFailure = createAction(GET_OPTED_USER_BRANDS_FAILURE);

export function getOptedUserBrands() {
  return dispatch => UserManager.getOptedUserBrands()
  .then(({ data }) =>{
   dispatch(requestOptedUserBrands(data))

  })
   .catch((error) => {
    dispatch(requestOptedUserBrandsFailure(error));
    if(error?.response?.status === 401){
      dispatch(showErrorSnackbar('Session is Expired!!!'));
    }else{
    dispatch(showErrorSnackbar('Failed to fetch opted user brands'));}
  });
}

